/* eslint-disable */
import URL from '_common/constants/URL';
import * as req from '../../utils/req';

/**
 * base64转 file
 * @param dataurl
 * @param filename
 */
export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Promise((resolve) => {
    resolve(new File([u8arr], filename, { type: mime }));
  });
};

export const canvasDataURL = (path, obj, filename) => {
  const img = new Image();
  img.src = path;
  return new Promise((resolve) => {
    img.onload = function () {
      const that = this;
      // 默认按比例压缩
      let w = that.width;
      let h = that.height;
      const scale = w / h;
      w = obj.width || w;
      h = obj.height || w / scale;
      let quality = 0.7; // 默认图片质量为0.7
      // 生成canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // 创建属性节点
      const anw = document.createAttribute('width');
      anw.nodeValue = w;
      const anh = document.createAttribute('height');
      anh.nodeValue = h;
      canvas.setAttributeNode(anw);
      canvas.setAttributeNode(anh);
      ctx.drawImage(that, 0, 0, w, h);
      // 图像质量
      if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
        quality = obj.quality;
      }
      // quality值越小，所绘制出的图像越模糊
      const base64 = canvas.toDataURL('image/jpeg', quality);
      dataURLtoFile(base64, filename).then((data) => {
        resolve(data);
      });
    };
  });
};

export const photoCompress = (file, w) => {
  const ready = new FileReader();
  /* 开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,
  如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容. */
  ready.readAsDataURL(file);
  return new Promise((resolve) => {
    ready.onload = function () {
      const re = this.result;
      canvasDataURL(re, w, file.name).then((data) => {
        resolve(data);
      });
    };
  });
};

/**
 * 上传到阿里云 OSS 平台
 */
export const uploadOss = (file, imageType, fileType = 0) => {
  // 先获取后端针对本次上传的配置信息
  return new Promise((resolve, reject) => {
    req.getDataPromise(URL.GET_KYC_UPLOAD_CONFIG).then((r) => {
      const {
        bucketName,
        accessKeyId,
        accessKeySecret,
        securityToken,
        path,
        id,
      } = r.data;
      // 开始走上传逻辑，初始化OSS示例
      let { endpoint } = r.data;
      endpoint = endpoint.replace('http://', ''); // 临时去掉 http:// 协议进行测试
      // eslint-disable-next-line no-undef
      const client = new OSS({
        accessKeyId,
        accessKeySecret,
        bucket: bucketName,
        stsToken: securityToken,
        endpoint,
        // secure: true
      });

      // path 表示上传的object name , file表示上传的文件
      client
        .multipartUpload(path, file)
        .then((result) => {
          if (result && result.res && result.res.status === 200) {
            // 上传成功之后，组装数据
            const callBackParams = {
              id,
              imageType,
              originalName: file.name,
              fileType,
            };
            resolve(callBackParams);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  });
};

/**
 * 上传OSS辅助方法
 * @param params
 * @param callback
 * @param isNeedOCR
 */
export const uploadOssCbUtil = (params, isNeedOCR = false) => {
  // 装配参数
  const { id, originalName, fileType } = params;
  let { imageType } = params;
  imageType = imageType ? parseInt(imageType, 10) : 0;
  const uploadUrl = isNeedOCR
    ? URL.GET_KYC_UPLOAD_OCR_CALLBACK
    : URL.GET_KYC_UPLOAD_CALLBACK;
  const uploadParams = {
    id,
    imageType,
    originalName,
    fileType,
  };
  return new Promise((resolve, reject) => {
    req.doPostData(
      uploadUrl,
      uploadParams,
      (r) => {
        // 调用回调函数，把上传的图片地址，类型和ID 传递到外部进行响应
        const cbInputParams = {
          imagePath: r.data.imagePath,
          imageId: id,
          imageType,
          name: originalName,
          idcardName: r.data.idcardName || '',
          idcardNumber: r.data.idcardNumber || '',
          idcardIssue: r.data.idcardIssue || '',
          idcardExpireDate: r.data.idcardExpireDate || '',
        };
        resolve(cbInputParams);
      },
      (r) => {
        reject(r);
      }
    );
  });
};

/**
 * 上传文件，无需OCR
 * @param params
 */
export const uploadOssCb = (params) => {
  return uploadOssCbUtil(params);
};

/**
 * 上传文件，需要OCR（可以是图片，pdf 等）
 * @param params
 */
export const uploadOssCbOCR = (params) => {
  return uploadOssCbUtil(params, true);
};

/**
 * 是否为图片
 * @param extension
 * @returns {boolean}
 */
export const isPic = (extension) => {
  const picExtension = ['jpg', 'jpeg', 'png', 'heic'];
  if (extension) {
    return picExtension.includes(extension);
  }
  return false;
};

/**
 * Default 10MB
 * 10 * 1024 * 1024 = 10485760 bytes
 * @param sizeLimit
 * @returns {bytes}
 */
export const getUploadLimitBytes = (sizeLimit = 10) => {
  const bytes = sizeLimit * 1024 * 1024;

  return bytes;
};

/**
 * 10MB
 * @returns {MB}
 */
export const sizeLimitMb = () => {
  return 10;
};
